<template>
  <div class="mobile-menu">
    <base-menu />
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss" scoped>

.mobile-menu {
  position: absolute;
  top: 4rem;
  bottom: .1rem;
  left: 0rem;
  right: 0rem;
  background-color: #eeeeee;
}
</style>
